module.exports = __webpack_public_path__ + "img/ye.d7aa4d19.svg";